import { gql } from '@apollo/client';

export const DELETE_FRAMEWORKRESULTINDICATOR = gql`
  mutation deleteFrameworkResultIndicator($id: ID!) {
    indicator: deleteFrameworkResultIndicator(id: $id) {
      id
    }
  }
`;
